import PaymentSDKCore from './core'

export default new PaymentSDKCore()
